import './HowToPay60SixtyInfo.css';

const HowToPay60SixtyInfo = () => {

  return (
    <section className="sixty60-savings-section">
      <div className="sixty60-savings-container">
        <h2 className="sixty60-savings-title">You asked, it's here!</h2>
        <p className="sixty60-savings-description">
          Customers with a Money Market Account can shop and pay on Checkers Sixty60 using their linked Xtra Savings card. Simply add the payment method once, and you're ready to check out.
        </p>

        <div className="sixty60-how-it-works">
          <div className="sixty60-video-container">
            <div className="sixty60-video-wrapper">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/OSCcW7qRZ4I"
                title="How to pay with Xtra Savings on Sixty60"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="sixty60-steps-container">
            <h3 className="sixty60-steps-title">Here's how it works</h3>
            <ol className="sixty60-steps-list">
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">1.</span>
                <span className="sixty60-step-text">Open Checkers Sixty60 App</span>
              </li>
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">2.</span>
                <span className="sixty60-step-text">Select <strong>"My Profile"</strong></span>
              </li>
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">3.</span>
                <span className="sixty60-step-text">Select <strong>"Bank Cards"</strong></span>
              </li>
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">4.</span>
                <span className="sixty60-step-text">Select <strong>"Add Card"</strong></span>
              </li>
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">5.</span>
                <span className="sixty60-step-text">Enter your <strong>Xtra Savings card number</strong></span>
              </li>
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">6.</span>
                <span className="sixty60-step-text">Select <strong>"Add Card"</strong></span>
              </li>
              <li className="sixty60-step-item">
                <span className="sixty60-step-number">7.</span>
                <span className="sixty60-step-text"><strong>Done!</strong> At check out select the Xtra Savings card as payment method, your CVV code will be the last 3-digits of your Xtra Savings card number</span>
              </li>
            </ol>

            <div className="sixty60-note">
              <strong>NB - You can only use funds from your VOUCHER account to pay</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowToPay60SixtyInfo;